import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "overlay"]

  connect() {
    this.videoTarget.addEventListener("ended", () => this.showOverlay())
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  play(e) {
    e?.preventDefault()
    this.overlayTarget.classList.add("banner__video-overlay--hidden")
    this.videoTarget.controls = true
    this.videoTarget.play()
  }

  showOverlay() {
    this.overlayTarget.classList.remove("banner__video-overlay--hidden")
    this.videoTarget.controls = false
  }

  handleKeydown(e) {
    if (!this.overlayTarget.classList.contains("banner__video-overlay--hidden")) {
      if (e.code === "Space" || e.key === "k") {
        e.preventDefault()
        this.play()
      }
      return
    }

    const focusTag = document.activeElement?.tagName?.toLowerCase()
    if (["input", "textarea", "select"].includes(focusTag)) return

    const video = this.videoTarget
    switch (e.key?.toLowerCase()) {
      case " ":
      case "k":
        e.preventDefault()
        video.paused ? video.play() : video.pause()
        break
      case "f":
        e.preventDefault()
        this.toggleFullscreen()
        break
      case "m":
        e.preventDefault()
        video.muted = !video.muted
        break
      case "j":
        e.preventDefault()
        video.currentTime = Math.max(0, video.currentTime - 10)
        break
      case "l":
        e.preventDefault()
        video.currentTime = Math.min(video.duration, video.currentTime + 10)
        break
      case "arrowleft":
        e.preventDefault()
        video.currentTime = Math.max(0, video.currentTime - 5)
        break
      case "arrowright":
        e.preventDefault()
        video.currentTime = Math.min(video.duration, video.currentTime + 5)
        break
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        e.preventDefault()
        const pct = parseInt(e.key, 10) * 10
        video.currentTime = (video.duration * pct) / 100
        break
    }
  }

  toggleFullscreen() {
    const wrap = this.element
    if (!document.fullscreenElement) {
      wrap.requestFullscreen?.() || wrap.webkitRequestFullscreen?.()
    } else {
      document.exitFullscreen?.() || document.webkitExitFullscreen?.()
    }
  }
}
